export const STORAGE_KEY = "yano-web-session-v2"

export const LANGUAGES = [
  { code: "arabic", label: "Arabic", flag: "🇸🇦" },
  { code: "chinese", label: "Chinese", flag: "🇨🇳" },
  { code: "english", label: "English", flag: "🇬🇧" },
  { code: "french", label: "French", flag: "🇫🇷" },
  { code: "german", label: "German", flag: "🇩🇪" },
  { code: "hindi", label: "Hindi", flag: "🇮🇳" },
  { code: "indonesian", label: "Indonesian", flag: "🇮🇩" },
  { code: "italian", label: "Italian", flag: "🇮🇹" },
  { code: "japanese", label: "Japanese", flag: "🇯🇵" },
  { code: "korean", label: "Korean", flag: "🇰🇷" },
  { code: "portuguese", label: "Portuguese", flag: "🇵🇹" },
  { code: "russian", label: "Russian", flag: "🇷🇺" },
  { code: "spanish", label: "Spanish", flag: "🇪🇸" },
  { code: "thai", label: "Thai", flag: "🇹🇭" },
  { code: "turkish", label: "Turkish", flag: "🇹🇷" },
  { code: "ukrainian", label: "Ukrainian", flag: "🇺🇦" },
  { code: "vietnamese", label: "Vietnamese", flag: "🇻🇳" }
]

export const GENDERS = [
  { code: "woman", label: "Woman" },
  { code: "man", label: "Man" },
  { code: "nonbinary", label: "Non-binary" },
  { code: "other", label: "Other" }
]

export const REPORT_REASONS = [
  "nudity",
  "harassment",
  "spam",
  "hateful conduct",
  "underage concern",
  "other"
]
